"use client";

import React from "react";
import { AwardTrustMarker } from "@interfaces/trust-markers.types";
import AckoDriveAwards from "./index";

export interface AckoDriveAwardsClientProps {
  awards: AwardTrustMarker[];
  className?: string;
  isInApp?: boolean;
}

const AckoDriveAwardsClient: React.FC<AckoDriveAwardsClientProps> = ({
  awards,
  className = "",
  isInApp
}) => {
  return (
    <AckoDriveAwards
      awards={awards}
      className={className}
      showViewAll={true}
      isInApp={isInApp}
    />
  );
};

export default AckoDriveAwardsClient;

